interface IStylesForMaxLinesOfText {
  maxLines: number;
  lineHeight: number;
  fontSizeInRem: number;
  overridingStyles?: any;
  useFullHeight?: boolean;
}

export const stylesForMaxLinesOfText = ({
  maxLines,
  lineHeight,
  fontSizeInRem,
  overridingStyles,
  useFullHeight,
}: IStylesForMaxLinesOfText) => {
  const calculatedHeightRems = maxLines * fontSizeInRem * lineHeight;

  const styles: React.CSSProperties = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: maxLines,
    lineHeight,
    maxHeight: `calc(${calculatedHeightRems}rem + 2px)`,
    height: useFullHeight ? `calc(${calculatedHeightRems}rem + 2px)` : 'auto',
    ...(overridingStyles || {}),
  };

  return styles;
};
